(() => {
  const init = root => {
    if (!root || root.dataset.wcEscapeReady === 'true') return;
    root.dataset.wcEscapeReady = 'true';

    const dataEl = root.querySelector('[data-wc-escape-data]');
    const form = root.querySelector('[data-wc-escape-form]');
    const status = root.querySelector('[data-wc-form-status]');
    const results = root.querySelector('[data-wc-results]');
    const resultsGrid = root.querySelector('[data-wc-results-grid]');
    const resultsSummary = root.querySelector('[data-wc-results-summary]');
    const editButton = root.querySelector('[data-wc-edit]');
    const vibeInputs = Array.from(root.querySelectorAll('input[name="vibes"]'));
    let destinations = [];

    const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, char => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
    }[char]));
    const list = value => Array.isArray(value) ? value.map(String) : [];
    const int = value => Number.parseInt(value, 10) || 0;
    const groupLabels = { solo: 'Solo', couple: 'Couple', friends: 'Friends', crew: 'Crew' };
    const vibeLabels = { beach: 'Beach', food: 'Food', party: 'Party', city: 'City', culture: 'Culture', slow: 'Slow' };
    const monthLabels = ['','Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];

    const beachSeasons = {
      'Palma de Mallorca': { strong: [6,7,8,9], shoulder: [5,10] },
      'Split': { strong: [6,7,8,9], shoulder: [5,10] },
      'Valencia': { strong: [6,7,8,9], shoulder: [5,10] },
      'Thessaloniki': { strong: [6,7,8,9], shoulder: [5,10] },
      'Ibiza': { strong: [6,7,8,9], shoulder: [5,10] },
      'Málaga': { strong: [6,7,8,9], shoulder: [5,10] },
      'Alicante': { strong: [6,7,8,9], shoulder: [5,10] },
      'Barcelona': { strong: [6,7,8,9], shoulder: [5,10] },
      'Nizza': { strong: [6,7,8,9], shoulder: [5,10] },
      'Athen': { strong: [6,7,8,9], shoulder: [5,10] },
      'Malta': { strong: [6,7,8,9,10], shoulder: [5] },
      'Faro': { strong: [6,7,8,9], shoulder: [5,10] }
    };

    try {
      destinations = JSON.parse(dataEl?.textContent || '[]').concat(Array.isArray(window.WCEscapeExtraData) ? window.WCEscapeExtraData : []).map(d => ({
        ...d,
        directFrom: list(d.directFrom), vibes: list(d.vibes), groupFit: list(d.groupFit), bestMonths: list(d.bestMonths),
        budgetFrom: int(d.budgetFrom), budgetTo: int(d.budgetTo), minNights: int(d.minNights), maxNights: int(d.maxNights)
      }));
    } catch (error) { destinations = []; }

    const updateVibeState = () => {
      const checked = vibeInputs.filter(input => input.checked);
      vibeInputs.forEach(input => { input.disabled = checked.length >= 2 && !input.checked; });
      const hint = root.querySelector('[data-wc-vibe-hint]');
      if (hint) hint.textContent = checked.length ? `${checked.length}/2 gewählt` : 'Max. 2';
    };
    vibeInputs.forEach(input => input.addEventListener('change', updateVibeState));
    updateVibeState();

    const getPrefs = () => {
      const fd = new FormData(form);
      return { from: String(fd.get('from') || ''), month: String(fd.get('month') || ''), nights: int(fd.get('nights')), group: String(fd.get('group') || ''), vibes: fd.getAll('vibes').map(String), budget: String(fd.get('budget') || '') };
    };

    const circularMonthDistance = (month, candidate) => {
      const raw = Math.abs(month - candidate);
      return Math.min(raw, 12 - raw);
    };

    const seasonInfo = (d, prefs) => {
      const month = int(prefs.month);
      const months = d.bestMonths.map(int).filter(Boolean);
      if (!month || !months.length) return { points: 0, max: 28, label: 'SAISON: PRÜFEN', short: 'Prüfen', tier: 'check' };
      if (months.includes(month)) return { points: 28, max: 28, label: 'SAISON: STARK', short: 'Stark', tier: 'strong' };
      const distance = Math.min(...months.map(candidate => circularMonthDistance(month, candidate)));
      if (distance === 1) return { points: 18, max: 28, label: 'SAISON: GUT', short: 'Gut', tier: 'good' };
      if (distance === 2) return { points: 8, max: 28, label: 'SAISON: SCHULTER', short: 'Schulterzeit', tier: 'shoulder' };
      return { points: 2, max: 28, label: 'SAISON: OFF-SEASON', short: 'Off-Season', tier: 'off' };
    };

    const beachInfo = (d, prefs) => {
      if (!prefs.vibes.includes('beach')) return { active: false, points: 0, max: 0, label: '', short: '', tier: '' };
      const month = int(prefs.month);
      const profile = beachSeasons[d.name];
      if (!d.vibes.includes('beach') || !profile) return { active: true, points: 0, max: 20, label: 'BEACH: NICHT FOKUS', short: 'Kein Beach-Fokus', tier: 'off' };
      if (profile.strong.includes(month)) return { active: true, points: 20, max: 20, label: 'BEACH: STARK', short: 'Badesaison', tier: 'strong' };
      if (profile.shoulder.includes(month)) return { active: true, points: 10, max: 20, label: 'BEACH: SCHULTER', short: 'Beach-Schulterzeit', tier: 'shoulder' };
      return { active: true, points: 0, max: 20, label: 'BEACH: OFF-SEASON', short: 'Keine Badesaison', tier: 'off' };
    };

    const scoreDestination = (d, prefs) => {
      let score = 0, max = 0;
      const direct = d.directFrom.includes(prefs.from);

      max += 24;
      if (direct) score += 24;
      else score += 3;

      const season = seasonInfo(d, prefs);
      max += season.max;
      score += season.points;

      const beach = beachInfo(d, prefs);
      max += beach.max;
      score += beach.points;

      const vibeMax = Math.max(14, prefs.vibes.length * 14);
      max += vibeMax;
      prefs.vibes.forEach(vibe => { if (d.vibes.includes(vibe)) score += 14; });

      max += 8;
      if (d.groupFit.includes(prefs.group)) score += 8;

      max += 7;
      if (prefs.nights >= d.minNights && prefs.nights <= d.maxNights) score += 7;

      max += 13;
      if (prefs.budget === 'flexible') score += 13;
      else {
        const ceiling = int(prefs.budget);
        if (d.budgetFrom <= ceiling) score += 13;
        else if (d.budgetFrom <= ceiling + 50) score += 5;
      }

      let percent = max ? Math.round((score / max) * 100) : 0;
      if (prefs.vibes.includes('beach') && d.vibes.includes('beach') && beach.tier === 'off') percent = Math.max(0, percent - 6);
      return { percent, direct, season, beach };
    };

    const buildShareText = (d, prefs, score) => {
      const route = score.direct ? `${prefs.from} → ${d.airportCode} · ${d.flightTimeNote}` : `${prefs.from} → ${d.airportCode} · Verbindung aktuell prüfen`;
      const seasonLine = score.beach.active ? `${score.season.label} · ${score.beach.label}` : score.season.label;
      return [`WEEKEND ESCAPE · ${score.percent}% MATCH`, `${d.name}, ${d.country}`, route, seasonLine, `${prefs.nights} Nächte · ${groupLabels[prefs.group] || prefs.group} · ${prefs.vibes.map(v => vibeLabels[v] || v).join(' + ')}`, '', d.hook, '', `FRIDAY — ${d.friday}`, `SATURDAY — ${d.saturday}`, `SUNDAY — ${d.sunday}`, '', `WEEKEND CULTURE PICK — ${d.wcPick}`].join('\n');
    };

    const bookingChecklist = (d, prefs, score) => {
      const vibeBase = prefs.vibes.includes('party')
        ? 'Unterkunft so wählen, dass Dinner- und Nightlife-Viertel nachts sicher und ohne langen Rückweg erreichbar sind.'
        : prefs.vibes.includes('beach')
          ? 'Unterkunft nicht nur nach Strandnähe wählen: Transfer zum Airport und Zugang zu Food oder Altstadt mitprüfen.'
          : 'Unterkunft in einem Viertel wählen, von dem mindestens zwei geplante Stationen zu Fuß oder direkt per ÖPNV erreichbar sind.';
      const seasonCheck = prefs.vibes.includes('beach')
        ? 'Luft- und Wassertemperatur sowie Wind für die konkreten Reisedaten prüfen; Sonnenschein allein bedeutet noch keine Badesaison.'
        : 'Wetter und Tageslicht für die konkreten Reisedaten prüfen und den längsten Outdoor-Block passend legen.';
      return [
        score.direct ? 'Direktflug für die konkreten Reisetage und den Rückflug am Sonntag oder Montag bestätigen.' : 'Verbindung, Umstieg und tatsächliche Tür-zu-Tür-Zeit prüfen; der Datensatz bestätigt aktuell keinen Direktflug.',
        'Ankunfts- und Abflugzeit gegen den 48–72h-Plan halten. Sehr späte Ankunft oder früher Rückflug kosten schnell einen halben Weekend-Tag.',
        vibeBase,
        seasonCheck,
        'Der angezeigte Richtwert gilt vor Ort pro Person. Flug und Unterkunft kommen hinzu.'
      ];
    };

    const sharePlan = async (d, prefs, score, button) => {
      const text = buildShareText(d, prefs, score), url = window.location.href;
      try {
        if (navigator.share) { await navigator.share({ title: `${d.name} · Weekend Escape`, text, url }); return; }
        if (navigator.clipboard) { await navigator.clipboard.writeText(`${text}\n\n${url}`); const old = button.textContent; button.textContent = 'LINK KOPIERT ✓'; window.setTimeout(() => { button.textContent = old; }, 1800); return; }
        status.textContent = 'Teilen ist in diesem Browser gerade nicht verfügbar.';
      } catch (error) { if (error && error.name !== 'AbortError') status.textContent = 'Teilen hat nicht funktioniert. Versuch es bitte noch einmal.'; }
    };

    const cardHtml = (d, index, prefs) => {
      const score = scoreDestination(d, prefs);
      const route = score.direct ? `${escapeHtml(prefs.from)} → ${escapeHtml(d.airportCode)} · ${escapeHtml(d.flightTimeNote)}` : `${escapeHtml(prefs.from)} → ${escapeHtml(d.airportCode)} · Verbindung prüfen`;
      const routeLabel = score.direct ? 'Direkt im Datensatz' : 'Route prüfen';
      const selectedVibes = prefs.vibes.filter(v => d.vibes.includes(v));
      const tags = [`${prefs.nights} Nächte`, groupLabels[prefs.group] || prefs.group, ...selectedVibes.map(v => vibeLabels[v] || v), score.season.label, ...(score.beach.active && d.vibes.includes('beach') ? [score.beach.label] : []), `ca. ${d.budgetFrom}–${d.budgetTo} € vor Ort`];
      const extraNight = prefs.nights === 3 ? '<p class="wc-escape__route-note"><strong>EXTRA NIGHT:</strong> Der Freitag–Sonntag-Plan ist der Kern. Die zusätzliche Nacht bleibt bewusst als Puffer für Anreise, Strand, einen langsameren Start oder einen längeren Sonntag.</p>' : '';
      const checklist = bookingChecklist(d, prefs, score);
      const booking = '<details class="wc-escape__plan"><summary>VOR DER BUCHUNG PRÜFEN</summary><div class="wc-escape__plan-inner"><ol>'+checklist.map(item => '<li>'+escapeHtml(item)+'</li>').join('')+'</ol><p class="wc-escape__route-note"><strong>BESTE MONATE IM DATENSATZ:</strong> '+d.bestMonths.map(month => monthLabels[int(month)]).filter(Boolean).join(', ')+'</p><p class="wc-escape__route-note"><strong>ROUTENHINWEIS:</strong> '+escapeHtml(d.routeNote)+'</p></div></details>';
      return `<article class="wc-escape__card ${index === 0 ? 'wc-escape__card--top' : ''}" data-wc-card="${index}">
        <div class="wc-escape__card-top"><div><p class="wc-escape__rank">${index === 0 ? 'TOP MATCH' : `MATCH 0${index + 1}`}</p><h3>${escapeHtml(d.name)}</h3><p class="wc-escape__country">${escapeHtml(d.country)}</p></div><div class="wc-escape__score"><strong>${score.percent}%</strong><span>Weekend Match</span></div></div>
        <div class="wc-escape__route"><span>${route}</span><span class="wc-escape__route-status ${score.direct ? '' : 'wc-escape__route-status--check'}"><i></i>${escapeHtml(routeLabel)}</span></div>
        <div class="wc-escape__tags">${tags.map(tag => `<span class="wc-escape__tag">${escapeHtml(tag)}</span>`).join('')}</div>
        <p class="wc-escape__hook">${escapeHtml(d.hook)}</p><p class="wc-escape__why">${escapeHtml(d.whyFit)}</p>
        <details class="wc-escape__plan" ${index === 0 ? 'open' : ''}><summary>${prefs.nights === 2 ? 'DEIN 48H PLAN' : 'DEIN CORE WEEKEND PLAN'}</summary><div class="wc-escape__plan-inner"><div class="wc-escape__day"><strong>FRIDAY</strong><p>${escapeHtml(d.friday)}</p></div><div class="wc-escape__day"><strong>SATURDAY</strong><p>${escapeHtml(d.saturday)}</p></div><div class="wc-escape__day"><strong>SUNDAY</strong><p>${escapeHtml(d.sunday)}</p></div>${extraNight}</div></details>
        ${booking}
        <div class="wc-escape__pick"><strong>WEEKEND CULTURE PICK</strong><p>${escapeHtml(d.wcPick)}</p></div>
        <div class="wc-escape__actions"><button type="button" class="wc-escape__action wc-escape__action--primary" data-wc-share="${index}">AN DIE CREW SENDEN</button></div>
      </article>`;
    };

    const updateUrl = prefs => {
      const url = new URL(window.location.href);
      url.searchParams.set('from', prefs.from); url.searchParams.set('month', prefs.month); url.searchParams.set('nights', String(prefs.nights)); url.searchParams.set('group', prefs.group); url.searchParams.set('vibes', prefs.vibes.join(',')); url.searchParams.set('budget', prefs.budget);
      history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    };

    const renderResults = (prefs, shouldScroll = true) => {
      if (!destinations.length) { status.textContent = 'Die Escape-Daten sind gerade nicht verfügbar.'; return; }
      const ranked = destinations.map(d => ({ d, s: scoreDestination(d, prefs) })).sort((a, b) => (b.s.percent - a.s.percent) || (Number(b.s.direct) - Number(a.s.direct)) || (b.s.season.points - a.s.season.points) || a.d.name.localeCompare(b.d.name)).slice(0, 3);
      resultsGrid.innerHTML = ranked.map((item, index) => cardHtml(item.d, index, prefs)).join('');
      resultsSummary.textContent = `${prefs.from} · ${monthLabels[int(prefs.month)] || ''} · ${prefs.nights} Nächte · ${prefs.vibes.map(v => vibeLabels[v] || v).join(' + ')} · Saison & Klima berücksichtigt`;
      results.hidden = false; status.textContent = ''; updateUrl(prefs);
      resultsGrid.querySelectorAll('[data-wc-share]').forEach(button => button.addEventListener('click', () => { const item = ranked[int(button.dataset.wcShare)]; if (item) sharePlan(item.d, prefs, item.s, button); }));
      if (shouldScroll) results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    form.addEventListener('submit', event => {
      event.preventDefault(); const prefs = getPrefs();
      if (!prefs.from || !prefs.month) { status.textContent = 'Bitte wähle Startflughafen und Monat.'; return; }
      if (!prefs.vibes.length) { status.textContent = 'Wähle mindestens einen Vibe.'; return; }
      renderResults(prefs, true);
    });

    editButton?.addEventListener('click', () => root.querySelector('.wc-escape__planner')?.scrollIntoView({ behavior: 'smooth', block: 'start' }));

    const hydrateFromUrl = () => {
      const params = new URLSearchParams(window.location.search);
      const from = params.get('from'), month = params.get('month'), nights = params.get('nights'), group = params.get('group'), vibes = (params.get('vibes') || '').split(',').filter(Boolean).slice(0, 2), budget = params.get('budget');
      if (!from || !month || !vibes.length) return;
      const fromEl = form.elements.namedItem('from'), monthEl = form.elements.namedItem('month');
      if (fromEl) fromEl.value = from; if (monthEl) monthEl.value = month;
      if (nights) { const el = Array.from(form.querySelectorAll('input[name="nights"]')).find(input => input.value === nights); if (el) el.checked = true; }
      if (group) { const el = Array.from(form.querySelectorAll('input[name="group"]')).find(input => input.value === group); if (el) el.checked = true; }
      if (budget) { const el = Array.from(form.querySelectorAll('input[name="budget"]')).find(input => input.value === budget); if (el) el.checked = true; }
      vibeInputs.forEach(input => { input.checked = vibes.includes(input.value); }); updateVibeState();
      const prefs = getPrefs(); if (prefs.from && prefs.month && prefs.vibes.length) renderResults(prefs, false);
    };
    hydrateFromUrl();
  };

  const boot = () => document.querySelectorAll('[data-wc-escape-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-wc-escape-root]') || event.target));
})();
